import { isServerMode } from '../../platform/server-mode';
/* Установщик «Озвучка проектов»: объект в window на том месте порядка скриптов, где стоял assets/bot-script.js.
   В серверном режиме тот же экран шаблона открывается разделом «Проекты» и работает с сервером через script-server.ts. */
import { createScript } from './engine';
import { definePageModule } from '../../bridge/page-module';
import { Projects } from './Projects';
import { createScriptServer } from './script-server';

export function installScript() {
  const serverMode = isServerMode();
  createScript(serverMode ? createScriptServer : null);
  definePageModule({
    global: 'BotProjects',
    PREFIX: 'pj',
    TESTS: [],
    S: {},
    Page: Projects,
    /* уход из раздела не ждёт паузы ввода: отложенное сохранение уходит сразу */
    extra: { leave: () => { (window as unknown as { BotScript?: { flush?(): void } }).BotScript?.flush?.(); return true; } },
  });
}
